import type { CompositionNode, FrameNode } from '@/core/document'
import type { Size } from '@/core/geometry'
import type { RenderContext } from '@/core/render/renderNode'
import {
  plainFrameInnerSize,
  type PlainFrameParams,
} from '@/tools/frame/params'

type PlainFrameNode = Omit<FrameNode, 'params'> & { params: PlainFrameParams }

export function renderPlainFrame(
  node: PlainFrameNode,
  targetSize: Size,
  context: RenderContext,
  renderChild: (child: CompositionNode, targetSize: Size, context: RenderContext) => void,
): void {
  const childSize = plainFrameInnerSize(targetSize, node.params.borderMm)
  const borderPixels = (targetSize.width - childSize.width) / 2
  if (childSize.width <= 0 || childSize.height <= 0) {
    throw new Error(`Plain frame "${node.id}" border leaves no room for its child`)
  }
  context.fillStyle = node.params.color
  context.fillRect(0, 0, targetSize.width, targetSize.height)
  context.save()
  context.translate(borderPixels, borderPixels)
  renderChild(node.child, childSize, context)
  context.restore()
}
